import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach Bearer token if present (fallback for non-cookie clients).
// Also set X-Bypass-SW-Cache when authenticated so the service worker skips
// its stale-while-revalidate strategy - admins editing/deleting content need
// fresh reads after every mutation, not cached lists.
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["X-Bypass-SW-Cache"] = "1";
    }
    return config;
});

export function resolveMediaUrl(url) {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    return url;
}

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Coś poszło nie tak. Spróbuj ponownie.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
